import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function StatItemOne() {
    return (
        <Box
            width="100%"
            sx={{
                background: '#f8f9fa',
                display: 'grid',
                placeItems: 'center',
                py: 10,
            }}
        >
            <Grid container maxWidth="lg" justifyContent="center" sx={{ px: 2 }}>
                <Grid item xs={12} md={8} textAlign="center">
                    <Typography
                        variant="h2"
                        color="prevailRed.main"
                        fontWeight="bold"
                        sx={{ fontSize: { xs: '3.5rem', md: '6rem' }, lineHeight: 1, mb: 2 }}
                    >
                        94%
                    </Typography>
                    <Typography variant="h4" color="grey.800" fontWeight="bold" mb={2}>
                        of companies say they need stronger protections for their Microsoft 365
                        and Google Workspace applications.
                    </Typography>
                    <Typography variant="body1" color="grey.500" sx={{ fontStyle: 'italic' }}>
                        Mimecast's State of Email Security 2023
                    </Typography>
                    <Box
                        sx={{
                            width: 60,
                            height: 4,
                            background: '#d90000',
                            mx: 'auto',
                            mt: 4,
                            borderRadius: 2,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
